import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';

import { ArrowLeftIcon, ArrowRightIcon } from 'assets/icons';

const styles = {
  iconButton: ({ palette, breakpoints }) => ({
    display: 'flex',
    width: 20,
    height: 20,
    padding: 0.5,
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${palette.text.primary}`,
    borderRadius: '50%',
    background: palette.common.white,
    cursor: 'pointer',
    outline: 'none',
    color: palette.primary.main,
    '&:hover': {
      background: palette.common.white,
    },
    '&.Mui-disabled': {
      color: palette.primary.main,
      background: palette.common.white,
      opacity: 0.5,
    },
    [breakpoints.up('sm')]: {
      width: 40,
      height: 40,
      borderWidth: 2,
      padding: 1,
    },
  }),
};

const ButtonNavigation = ({ isPrev = false, onClick, customStyles = {}, ...buttonProps }) => (
  <IconButton sx={[styles.iconButton, customStyles]} onClick={onClick} {...buttonProps}>
    {isPrev ? <ArrowLeftIcon /> : <ArrowRightIcon />}
  </IconButton>
);

ButtonNavigation.propTypes = {
  isPrev: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  customStyles: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
};
export default ButtonNavigation;
